import { getUserInfoAPI } from '../../apis/userApi';
import React from 'react';

const UserContext = React.createContext({});

const UserProvider = ({ children }) => {
  const [user, setUser] = React.useState({});

  React.useEffect(() => {
    let isAlive = true;
    const getUserInfo = async () => {
      try {
        const data = await getUserInfoAPI();
        if (data && isAlive) {
          setUser(data);
        }
      } catch (e) {
        console.log(e);
      }
    };
    getUserInfo();
    return () => {
      isAlive = false;
    };
  }, []);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  return React.useContext(UserContext);
};

export const withUser = WrapComponent => {
  return props => {
    const user = useUser();
    return (
      <UserProvider value={user}>
        <WrapComponent {...props} />
      </UserProvider>
    );
  };
};

export default UserProvider;
